var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationDress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4815 36.75C36.1596 22.305 26.7453 16.9669 26.7453 16.9669C26.7453 12.9244 29.734 10.2488 31.6784 8.93626C32.5859 8.32314 32.8821 7.10439 32.3965 6.10689L31.8565 4.99689C31.4121 4.08564 30.4146 3.56439 29.4528 3.81376C27.1484 4.41189 25.0671 5.83501 23.7959 6.85314C23.0309 7.46626 21.9715 7.46626 21.2046 6.85314C19.9315 5.83501 17.8503 4.41189 15.5478 3.81376C14.5859 3.56251 13.5884 4.08376 13.144 4.99689L12.604 6.10689C12.1184 7.10439 12.4165 8.32501 13.3221 8.93626C15.2665 10.2488 18.2553 12.9244 18.2553 16.9669C18.2553 16.9669 8.83902 22.305 7.51902 36.75C7.20965 40.1269 10.9465 42.2569 13.5003 40.11L13.5471 40.0706C15.1165 38.7525 17.8146 38.5912 19.2959 40.0162C20.9909 41.6475 23.9478 41.6606 25.6634 40.0575C27.1878 38.6344 29.9084 38.7694 31.5021 40.11C34.054 42.2587 37.7909 40.1287 37.4815 36.75Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2627 16.9688H26.7377",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationDress);
export default __webpack_public_path__ + "static/media/navigation-dress.193e66c2.svg";
export { ForwardRef as ReactComponent };